export const useStyles = (theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  inputRoot: {
    height: 70,
  },
  tableFormWidth: {
    width: 150,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  tableCellRoot: {
    paddingTop: 0,
  },
});
